/* GET */

export function get<T, P1 extends keyof NonNullable<T>>(obj: T, prop1: P1): NonNullable<T>[P1];

export function get<T, P1 extends keyof NonNullable<T>, P2 extends keyof NonNullable<NonNullable<T>[P1]>>(
    obj: T,
    prop1: P1,
    prop2: P2
): NonNullable<NonNullable<T>[P1]>[P2];

export function get<
    T,
    P1 extends keyof NonNullable<T>,
    P2 extends keyof NonNullable<NonNullable<T>[P1]>,
    P3 extends keyof NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>
>(obj: T, prop1: P1, prop2: P2, prop3: P3): NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>[P3];

export function get<
    T,
    P1 extends keyof NonNullable<T>,
    P2 extends keyof NonNullable<NonNullable<T>[P1]>,
    P3 extends keyof NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>,
    P4 extends keyof NonNullable<NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>[P3]>
>(
    obj: T,
    prop1: P1,
    prop2: P2,
    prop3: P3,
    prop4: P4
): NonNullable<NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>[P3]>[P4];

export function get<
    T,
    P1 extends keyof NonNullable<T>,
    P2 extends keyof NonNullable<NonNullable<T>[P1]>,
    P3 extends keyof NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>,
    P4 extends keyof NonNullable<NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>[P3]>,
    P5 extends keyof NonNullable<NonNullable<NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>[P3]>[P4]>
>(
    obj: T,
    prop1: P1,
    prop2: P2,
    prop3: P3,
    prop4: P4,
    prop5: P5
): NonNullable<NonNullable<NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>[P3]>[P4]>[P5];

export function get(obj: any, ...properties: string[]): any {
    return obj && properties.reduce((result, prop) => (result == null ? null : (result[prop])), obj);
}

export function getAny(obj: any, ...properties: string[]): any {
    return obj && properties.reduce((result, prop) => (result == null ? null : result[prop]), obj);
}

/* SET */

export function set<T, P1 extends keyof NonNullable<T>>(obj: T, value: NonNullable<T>[P1], prop1: P1): void;

export function set<T, P1 extends keyof NonNullable<T>, P2 extends keyof NonNullable<NonNullable<T>[P1]>>(
    obj: T,
    value: NonNullable<NonNullable<T>[P1]>[P2],
    prop1: P1,
    prop2: P2
): void;

export function set<
    T,
    P1 extends keyof NonNullable<T>,
    P2 extends keyof NonNullable<NonNullable<T>[P1]>,
    P3 extends keyof NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>
>(obj: T, value: NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>[P3], prop1: P1, prop2: P2, prop3: P3): void;

export function set<
    T,
    P1 extends keyof NonNullable<T>,
    P2 extends keyof NonNullable<NonNullable<T>[P1]>,
    P3 extends keyof NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>,
    P4 extends keyof NonNullable<NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>[P3]>
>(
    obj: T,
    value: NonNullable<NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>[P3]>[P4],
    prop1: P1,
    prop2: P2,
    prop3: P3,
    prop4: P4
): void;

export function set<
    T,
    P1 extends keyof NonNullable<T>,
    P2 extends keyof NonNullable<NonNullable<T>[P1]>,
    P3 extends keyof NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>,
    P4 extends keyof NonNullable<NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>[P3]>,
    P5 extends keyof NonNullable<NonNullable<NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>[P3]>[P4]>
>(
    obj: T,
    value: NonNullable<NonNullable<NonNullable<NonNullable<NonNullable<T>[P1]>[P2]>[P3]>[P4]>[P5],
    prop1: P1,
    prop2: P2,
    prop3: P3,
    prop4: P4,
    prop5: P5
): void;

export function set(obj: any, value: any, ...props: string[]): void {
    setRecurse(obj, value, props);
}

function setRecurse(obj: any, value: any, path: string[]): void {
    if (path.length > 1) {
        if (!obj.hasOwnProperty(path[0]) || typeof obj[path[0]] !== 'object') {
            obj[path[0]] = {};
        }

        setRecurse(obj[path[0]], value, path.slice(1));
    } else {
        obj[path[0]] = value;
    }
}

export function setAny(obj: any, value: any, ...props: string[]): void {
    setRecurse(obj, value, props);
}
